<template>
  <v-layout class="pa-0 ma-0 container-special-infoCotacao" row justify-center>
    <v-card style="width: 100%" class="dialog">
      <v-card-title class="primary">
        <span class="headline" style="padding-left: 16px">
          SOLICITAÇÃO DE COTAÇÃO</span
        >
      </v-card-title>
      <v-form v-model="validFormSolicitacao">
        <v-card-text class="px-4">
          <div>
            <h3
              style="color: #555555; font-weight: 500; font-size: 16px; font-family: 'Roboto Medium', 'Roboto Regular', 'Roboto', sans-serif;"
            >
              Informe os detalhes da sua solicitação e anexe os arquivos necessários.
            </h3>
          </div>
          <v-flex mb-6 class="textblack">
            Mensagem
            <v-flex xs12 sm2 md12>
              <v-textarea
                v-model="descricao"
                class="textarea"
                :rules="[regras.length(254)]"
              ></v-textarea>
            </v-flex>
          </v-flex>
          <div grid-list-md>
            <v-layout wrap>
              <v-flex align-center d-flex xs12 sm6 md3>
                <a flat> </a>
              </v-flex>
              <v-flex xs12 md12 class="pl-4">
                <input type="text" readonly v-model="arquivo.nome" />
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-flex>
              <v-flex xs3 md3 class="pl-4">
                <div class="row">
                  <label
                    for="file-upload"
                    :class="['button-custom-label', { disabled: loading }]"
                  >
                    ANEXAR ARQUIVO
                  </label>
                  {{
                    arquivo.length > 1
                      ? "(" + arquivo.length + " Anexos)"
                      : "(" + arquivo.length + " Anexo)"
                  }}
                </div>
                <input
                  @change.prevent="processarArquivo($event)"
                  id="file-upload"
                  type="file"
                  ref="file"
                  accept="image/png, image/jpeg, .pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel "
                  :disabled="loading"
                  multiple
                  v-if="dialogFile"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-form>
      <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
      <v-card-actions class="px-5 pb-5">
        <div v-if="!arquivoValido">
          <small class="text-error">{{
            erro === undefined ? "Não foi possível importar o documento." : erro
          }}</small>
          <br />
        </div>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="$emit('fechar')">VOLTAR </v-btn>
        <v-btn
          :disabled="!validFormSolicitacao"
          color="primary"
          @click="salvarDadoDaApolice"
          >SOLICITAR</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-layout row justify-center>
      <v-dialog persistent v-model="dialogProgress" max-width="800px">
        <v-card class="dialog">
          <v-card-title class="primary">
            <span class="headline">AVALIANDO ITENS</span>
          </v-card-title>
          <v-card-text class="py-5 px-4">
            <div grid-list-md>
              <v-layout wrap>
                <v-flex align-center d-flex xs12>
                  <span>
                      Por favor, aguarde o processamento. Isso pode levar alguns minutos.
                  </span>
                </v-flex>
                <v-flex align-center d-flex xs12>
                  <v-progress-linear
                    heigth="2px"
                    indeterminate
                    color="primary"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>

        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="mostrarModalErroChassiDuplicado" max-width="570px">
        <ModalErroChassiExistente
          :mensagemErro = "mensagensErroChassiDuplicado"
          :textoSalvarOuEmitir = "'SALVAR'"
          :mostrarBotaoSalvarOuEmitir = "false"
          @fecharModalErroChassiExistente="
            mostrarModalErroChassiDuplicado = false;
            $emit('fecharModalErroChassiExistente');
          "
          @emitirOuSalvarPropostaComErros="
            mostrarModalErroChassiDuplicado = false;
            $emit('emitirOuSalvarPropostaComErros');
          ">
        </ModalErroChassiExistente>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>
<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalErroChassiExistente from "../frota/ModalErroChassiExistente.vue";

export default {
  name: "ModalSolicitacaoCorretorReserva",
  components: {
    ModalErroChassiExistente
  },
  data: () => ({
    textoLivreAnexo: null,
    menu1: false,
    dialogCotacaoAnexo: false,
    tabs: null,
    arquivo: [],
    loading: false,
    arquivoValido: true,
    arquivoFaltante: [],
    validFormSolicitacao: true,
    descricao: null,
    dialogFile: true,
    conteudoPlanilha: null,
    erroPlanilha: null,
    valid: true,
    dialogProgress: false,
    disable: true,
    snack: false,
    snackColor: "",
    snackText: "",
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    },
    idCorretor: null,
    regras: {
      cnpj: [v => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "Valor incorreto"],
      notNull: [
        v =>
          !!(v instanceof Array ? v.length : v !== null) ||
          "Você não pode deixar este campo em branco"
      ],
      length: len => v =>
        (v || "").length <= len ||
        `Número máximo de caractéres ultrapassado, requer no máximo ${len} caractéres.`
    },
    erro: null,
    mostrarModalErroChassiDuplicado: false,
    mensagensErroChassiDuplicado: null,
  }),
  methods: {
    salvarDadosCorretor(idApolice, corretor) {

      corretor.descricao = this.descricao;
      axios
        .post(
          `${process.env.URL_CORRETORMS}/v1/salvarSolicitacaoCorretorReserva?idApolice=${idApolice}`,
          corretor,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.idCorretor = response.data.id;
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.snack = true;
            this.snackColor = "red";
            this.snackText = error.response.data.message;
          }
          this.dialogCotacaoAnexo = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.validarArquivos(this.idCorretor);
          } ,1000)
        });
    },

    verificarSeExisteChassiDuplicado(dadosEnvio, corretor) {
      const formData = new FormData();
      formData.append("jsonListaVeiculos", JSON.stringify(dadosEnvio.conteudoPlanilha));
      formData.append("idApolice", 0)

      axios
        .post(`${process.env.URL_PLANILHAMS}/v1/encontrarErrosListaVeiculos`, formData, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then((response) => {
          this.salvarProposta(dadosEnvio, corretor)
          this.loading = false;
        })
        .catch(error => {
          this.mensagensErroChassiDuplicado = error.response.data.message;
          this.mostrarModalErroChassiDuplicado = true;

          this.loading = false;
        });
    },

    salvarDadoDaApolice() {
      this.loading = true;
      let dadosEnvio = this.$store.getters["formCorretorReserva/conteudoSalvarCotacao"];
      const corretor = this.$store.getters["formCorretorReserva/dadosCorretorReserva"];

      this.verificarSeExisteChassiDuplicado(dadosEnvio, corretor);
    },

    salvarProposta(dadosEnvio, corretor) {
      axios
        .post(
          `${process.env.URL_CALCULOMS}/v1/salvarProposta`,
          dadosEnvio,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.salvarDadosCorretor(response.data, corretor);
        })
        .catch(error => {
          this.dialogError = true;
          if (error.response && error.response.data) {
            this.errorMessage =
              error.response.data.erros || error.response.data.message;
          } else {
            this.errorMessage = error.response.data.message;
          }
        })
    },

    fechar() {
      this.$emit("fechar");
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },

    validarArquivos(id) {
      this.dialogProgress = true;
      if (this.arquivo.length > 0) {
        const formData = new FormData();

        for (var i = 0; i < this.$refs.file.files.length; i++) {
          let file = this.$refs.file.files[i];
          formData.append("arquivoCorretorReserva", file);
        }
        axios
          .post(
            `${process.env.URL_CORRETORMS}/v1/salvarArquivosCorretorReserva/${id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          )
          .then(response => {
            if (response) {
              this.arquivoValido =
                typeof response.data.valido === "boolean"
                  ? response.data.valido
                  : true;            }
          })
          .catch(error => {
            this.arquivoValido = false;
            this.erro = error.response.data.message;
          })
          .finally(() => {
            this.save;
            this.dialogProgress = false;
            this.loading = false;
            this.dialogCotacaoAnexo = false;
            this.$emit("atualizar");

          });
      } else {
        this.save();
        this.dialogProgress = false;
        this.loading = false;
        this.dialogCotacaoAnexo = false;
        this.$emit("atualizar");
      }
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo com sucesso.";
    },
    processarArquivo(event) {
      this.arquivo = [];
      for (const file of event.target.files) {
        this.arquivo.push(file);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalSolicitacaoCorretorReserva.vue